import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import counterReducer from '../components/counterSlice'
import colorReducer from '../components/counterColor'
import { apiData } from "../components/apiData";

export const store = configureStore({
    reducer:{
        counter:counterReducer,
        colorslice:colorReducer,
        [apiData.reducerPath]:apiData.reducer
    },
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware().concat(apiData.middleware)
})

setupListeners(store.dispatch)